import React from 'react';

const Modal = ({ 
  visible = false, 
  children, 
  animationType = 'none',
  transparent = false,
  onRequestClose,
  onShow,
  style,
  ...props 
}) => {
  React.useEffect(() => {
    if (visible && onShow) {
      onShow();
    }
  }, [visible, onShow]);
  
  if (!visible) return null;
  
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: transparent ? 'transparent' : 'rgba(0, 0, 0, 0.5)'
  };
  
  // The dialog of the Strike AI style template (docs/STRIKE_STYLE.md, section 6)
  const modalStyle = {
    backgroundColor: 'var(--popover)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-card)',
    boxShadow: 'var(--shadow-md)',
    padding: 20,
    maxWidth: '90%',
    maxHeight: '90%',
    overflow: 'auto',
    ...style
  };
  
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && onRequestClose) {
      onRequestClose();
    }
  };
  
  return (
    <div 
      style={overlayStyle} 
      onClick={handleOverlayClick}
      {...props}
    >
      <div style={modalStyle}>
        {children}
      </div>
    </div>
  );
};

export default Modal;